<template>
  <div>
    <div class="location">当前位置: 违规公示</div>
    <div class="mationbox">
      <el-form ref="form" :model="form" label-width="80px" size="mini">
        <el-form-item label="发布日期:">
          <span
            class="boxdate"
            @click="onpublishTimeArea('')"
            :class="[form.publishTimeArea == '' ? 'contentbox' : '']"
            >不限</span
          ><span
            class="boxdate"
            @click="onpublishTimeArea('1')"
            :class="[form.publishTimeArea == '1' ? 'contentbox' : '']"
            >今天</span
          >
          <span
            class="boxdate"
            @click="onpublishTimeArea('3')"
            :class="[form.publishTimeArea == '3' ? 'contentbox' : '']"
            >3天内</span
          ><span
            class="boxdate"
            @click="onpublishTimeArea('7')"
            :class="[form.publishTimeArea == '7' ? 'contentbox' : '']"
            >7天内</span
          >
          <span
            class="boxdate"
            @click="onpublishTimeArea('15')"
            :class="[form.publishTimeArea == '15' ? 'contentbox' : '']"
            >15天内</span
          ><span
            class="boxdate"
            @click="onpublishTimeArea('30')"
            :class="[form.publishTimeArea == '30' ? 'contentbox' : '']"
            >30天内</span
          >
        </el-form-item>
        <el-row :gutter="20">
          <!-- <el-col :span="5">
            <el-form-item label="公示编号:">
              <el-input v-model="form.noticeCode"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="公示标题:">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="5">
            <el-form-item label="发布分类:">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <el-form-item label="发布日期:">
              <el-date-picker
                v-model="value"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onChange(value)"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-button size="mini" type="primary" @click="onsend">查询</el-button>
          <el-button size="mini" @click="onremove">清除</el-button>
        </el-row>
        <el-form-item label="排序:">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-sort-up"
            v-if="flag"
            @click="onsort"
            >公示时间</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-sort-down"
            v-else
            @click="onsort"
            >公示时间</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="punishment"
        style="width: 100%"
        :show-header="false"
        :row-class-name="tableRowClassName"
        show-overflow-tooltip
      >
        <el-table-column prop="publishTime" label="新" width="50" align="right">
          <template v-slot="scope">
            <span class="font-shadow" v-if="scope.row.lately == 1">new</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="编号">
          <template v-slot="scope"
            ><span class="linktab" @click="ondefault(scope.row.id)">{{
              scope.row.noticeCode
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="date" label="标题">
          <template v-slot="scope"
            ><span class="linktab" @click="ondefault(scope.row.id)">{{
              scope.row.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="查看次数" width="180">
          <template v-slot="scope">
            <span>查看 {{ scope.row.readTimes }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="publishTime" label="时间" width="180">
        </el-table-column>
      </el-table>
      <div v-if="total">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flag: false,
      total: null,
      punishment: [],
      form: {
        pageIndex: 1,
        pageSize: 10,
        publishTimeArea: '',
        title: '',
        noticeCode: '',
        publishTimeEnd: '',
        publishTimeStart: '',
        sort: 'PUBLISH_TIME,desc'
      },
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        },
        {
          value: '选项3',
          label: '蚵仔煎'
        },
        {
          value: '选项4',
          label: '龙须面'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      value: ''
    }
  },
  created() {
    this.punishmentList()
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      console.log(row, rowIndex)
      if (rowIndex % 2 != 1) {
        return 'warning-row'
      }
    },
    onpublishTimeArea(o) {
      console.log(o)
      this.form.publishTimeArea = o
      this.punishmentList()
    },
    async punishmentList() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let data = await this.$api.notice.punishmentList(this.form)
      console.log(data)
      loading.close()
      this.punishment = data.data
      this.total = data.total
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val
      console.log(`当前页: ${val}`)
      this.punishmentList()
    },
    ondefault(id) {
      let routerJump = this.$router.resolve({
        path: '/home/defaultDetail',
        query: { id }
      })
      window.open(routerJump.href, '_blank')
    },
    onChange(val) {
      console.log(val)
      val[0]
      this.form.publishTimeStart = val[0]
      this.form.publishTimeEnd = val[1]
    },
    onsend() {
      console.log(this.form)
      this.punishmentList()
    },
    onremove() {
      this.value = ''
      this.form.publishTimeArea = ''
      this.form.noticeCode = ''
      this.form.title = ''
      this.form.publishTimeEnd = ''
      this.form.publishTimeStart = ''
      this.punishmentList()
    },
    onsort() {
      this.flag = !this.flag
      console.log(this.flag)
      if (this.flag) {
        this.form.sort = 'PUBLISH_TIME,asc'
      } else {
        this.form.sort = 'PUBLISH_TIME,desc'
      }
      this.punishmentList()
    }
  }
}
</script>
<style lang="less" scoped>
.mationbox {
  // background: whitesmoke;
  min-height: 450px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  //   background: rgb(241, 241, 241);
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.boxdate {
  display: inline-block;
  margin-right: 30px;
  cursor: pointer;
}
/deep/.el-button {
  font-size: 13px;
  padding: 7px 15px;
}
/deep/.el-table .warning-row {
  background: rgb(236, 235, 235);
}
.location {
  color: rgb(92, 88, 88);
  font-weight: 460;
  padding: 10px;
  margin-top: 20px;
}
.contentbox {
  color: #2587ff;
}
.font-shadow {
  font-size: 12px;
  text-align: center;
  //   letter-spacing: 10px;
  font-weight: 700;
  color: #eb5e33;
  //   text-shadow: 4px 4px 0 #2260b1;
  font-style: italic;
}
/deep/.el-table tbody tr:hover > td {
  background-color: transparent !important;
}
</style>
